import { EntityHelpers } from '@main/helpers/entity.helpers';
import { EntityItem } from '@main/models';
import { EntityKeyword } from '../../models/EntityKeyword';
import { RouteIdsItem } from '../../types/types';

export class KeywordsHelpers {
    static createKeywordsEntities(keywords: RouteIdsItem[]): EntityKeyword[] {
        return keywords.map((v) => this.createKeywordEntity(v));
    }

    static createKeywordEntity(keyword: RouteIdsItem): EntityKeyword {
        return new EntityKeyword(keyword as string);
    }

    /* Groups are expanded into the keywords they hold: the datasets are queried by the keyword strings, a group id
     * would resolve to a different scope. */
    static serializeKeywords(entities: EntityItem[], globalParentheses = true): string {
        return EntityHelpers.serializeEntitiesIds(entities, {
            globalParentheses,
            extractGroupsIds: true,
            plain: true,
        });
    }

    static serializeCampaignsIds(ids: number[]): string {
        if (!ids.length) {
            return;
        }

        return ids.length === 1 ? ids[0].toString() : `(${ids.join(',')})`;
    }
}
